import React from 'react';
import { THEME_ID, ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezonePlugin from 'dayjs/plugin/timezone';
import { muiPounceV2 } from '../theme';
import GlobalStyles from './GlobalStyles';

interface ThemeProviderProps {
  /** The theme mode to use */
  mode?: 'light' | 'dark';
  children: React.ReactNode;
}

dayjs.extend(utc);
dayjs.extend(timezonePlugin);

// Creating a ThemeProvider for PounceV2 following the same pattern as the Pounce ThemeProvider
const ThemeProvider = ({ children, mode = 'dark' }: ThemeProviderProps) => {
  // Create the PounceV2 MUI theme
  const pounceV2MuiTheme = React.useMemo(() => muiPounceV2(mode), [mode]);

  return (
    <MuiThemeProvider theme={{ [THEME_ID]: pounceV2MuiTheme }}>
      <LocalizationProvider dateAdapter={AdapterDayjs} dateLibInstance={dayjs}>
        <GlobalStyles />
        {children}
      </LocalizationProvider>
    </MuiThemeProvider>
  );
};

export default ThemeProvider;
